// extracted by mini-css-extract-plugin
export var externalIcon = "ExternalLink-module--externalIcon--7xdeg";
export var link = "ExternalLink-module--link--U+VNx";